<template>
  <vx-card class="w-full">
    <div v-if="hasChildrenCompanies || (hasPermission && visibleSave)" class="flex justify-end gap-4">
      <vs-button v-if="hasChildrenCompanies" color="secondary" type="border" @click="onClickMoveList">{{ $t('목록') }}</vs-button>
      <vs-button v-if="hasPermission && visibleSave" color="secondary" @click="save">{{ $t('저장') }}</vs-button>
    </div>
    <FileUploader type="images" title="이미지 업로드" :readonly="!hasPermission" v-model="form.fileList" @input="inputFilelist" />
    <!-- 파일첨부 -->
    <FileDownload :isChange="hasPermission" class="mt-7" />
  </vx-card>
</template>

<script>
import FileDownload from "@/components/FileDownload.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import FileUploader from "@/components/FileUploader";

export default {
  components: {
    FileDownload,
    FileDownloadPost,
    FileUploader,
  },
  data() {
    return {
      projectId: parseInt(this.$route.params.proj_id),
      boardId: parseInt(this.$route.params.boardId),
      permission: { c: 0, r: 0, u: 0, d: 0, v: 0 },
      isLoadPost: false,
      visibleSave: false,
      hasChildrenCompanies: false,

      form: {
        fileList: [],
      },
    };
  },
  computed: {
    hasPermission() {
      return this.permission.c === 1;
    },
  },
  async created() {
    await this.loadPermission();
    await this.loadPost();
    await this.getChildrenCompanies();
  },
  methods: {
    async loadPermission() {
      if (Number.isInteger(this.boardId)) {
        let boards = this.$store.state.member.memberInfo.boards;
        if (!boards) {
          await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
          boards = this.$store.state.member.memberInfo.boards;
        }

        let board = boards.find((b) => parseInt(b.id) === parseInt(this.boardId));
        if (!!board && !!board.pivot) {
          if (board.pivot.project_id) {
            // 프로젝트에 맞는 권한이 있는지 다시 조사한다
            board = boards.find((b) => parseInt(b.pivot.board_id) === parseInt(this.boardId) && parseInt(b.pivot.project_id) === parseInt(this.projectId));
            this.permission = { ...board.pivot };
          } else {
            this.permission = { ...board.pivot };
          }
        }
      }
    },

    // 게시물 불러오기
    async loadPost() {
      const params = {
        projectId: this.projectId,
        boardId: this.boardId,
        page: 1,
        perPage: 1,
        orderTarget: "created_at",
        orderDirection: "desc",
        companyIds: [this.$store.state.member.memberInfo.company_id],
      };

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", params);
      const { data } = response;

      if (data.length > 0) {
        const post = data[0];
        this.form.fileList = JSON.parse(post.post_content).body.fileList;
        this.$nextTick(() => {});
      }

      setTimeout(() => {
        this.isLoadPost = true;
      }, 100);
    },

    inputFilelist() {
      if (!this.isLoadPost) return;
      this.visibleSave = true;
    },

    getChildrenCompanies() {
      this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId: this.projectId }).then((value) => {
        const companyTree = value;
        const list = [];
        for (const com of companyTree) {
          list.push(com.descendant);
        }

        this.hasChildrenCompanies = list.length > 1;
      });
    },
    onClickMoveList() {
      this.$router.push({ name: "list|tab", params: { proj_id: this.projectId, boardId: this.boardId } });
    },
    async save() {
      const form = {
        header: {
          full: new Date().format("yyyy-MM-dd"),
          month: new Date().getMonth() + 1,
          year: new Date().getFullYear(),
        },
        body: this.form,
        summary: {},
      };

      const projectId = this.projectId;
      const boardId = this.boardId;

      const title = "추진 목표";
      const content = JSON.stringify(form);

      await this.$store.dispatch("board/CREATE_POST", {
        projectId,
        boardId,
        title,
        content,
      });

      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "알림",
          message: "저장이 완료되었습니다.",
        },
      });
      window.dispatchEvent(customAlert);
    },
  },
};
</script>

<style scoped lang="scss"></style>
